








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'price-component',
})
export default class PriceComponent extends Vue {
  protected prefix='';

  protected suffix='';

  protected value='';

  @Prop({
    type: String,
    default: '',
  })
  protected price: string | undefined;

  mounted() {
    if (this.price) {
      const price = this.price.match(/([0-9]+,[0-9]+.€)/gm)?.[0];
      if (!price) return;
      this.value = price;
      // eslint-disable-next-line prefer-destructuring
      this.prefix = this.price.split(price)[0];
      // eslint-disable-next-line prefer-destructuring
      this.suffix = this.price.split(price)[1];
    }
  }
}
